import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import {
    Label,
    LabelProps,
    LabelFontFamily,
} from 'UI-Dash-Commons-UI';
import { PageContentProps, IndentWidthType } from './..';

const DocsPageContentText: FunctionComponent<LabelProps & PageContentProps> = ({
                                                                                   text,
                                                                                   fontFamily = LabelFontFamily.FONT_FAMILY_REGULAR,
                                                                                   withIndent = IndentWidthType.NONE,
                                                                                   ...rest
}) =>
{
    return <DocsPageContentTextWrapper text={text} fontFamily={fontFamily} withIndent={withIndent} {...rest}>
        {text}
    </DocsPageContentTextWrapper>;
};

export default DocsPageContentText;

const DocsPageContentTextWrapper = styled( Label )<{ withIndent: IndentWidthType }>`
  display: inline;

  font-size: 16px;
  line-height: 22px;

  padding-left: 0px;
  padding-left: ${props => props.withIndent === IndentWidthType.NONE && '0px'};
  padding-left: ${props => props.withIndent === IndentWidthType.SMALL && '50px'};
  padding-left: ${props => props.withIndent === IndentWidthType.MEDIUM && '100px'};
  padding-left: ${props => props.withIndent === IndentWidthType.LARGE && '150px'};

  color: ${props => props.theme.colors.blackLight};
`;
